if (!customElements.get('son-daireler')) {
  class SonDaireler extends HTMLElement {
    constructor() {
      super();
      this.splideContainer = this.querySelector('.splide');
    }

    applyCampaignStyles() {
      const priceElements = this.querySelectorAll('.flats__card-price-value');

      priceElements.forEach((priceElement) => {
        const appliedRaw = (priceElement.dataset.campaignApplied || '').toLowerCase();
        const campaignRate = Number(priceElement.dataset.campaignRate);
        const originalCash = Number(priceElement.dataset.originalCash);
        const isCampaignApplied = appliedRaw === 'true';
        const hasValidCampaignRate = Number.isFinite(campaignRate) && campaignRate > 0;
        const hasOriginalCash = Number.isFinite(originalCash) && originalCash > 0;
        const card = priceElement.closest('.flats__card');
        const priceContainer = priceElement.parentElement;

        priceElement.classList.toggle('flats__card-price-value--campaign', isCampaignApplied);
        priceElement.classList.toggle('flats__card-price-value--default', !isCampaignApplied);

        if (priceContainer) {
          let priceMain = priceContainer.querySelector('.flats__card-price-main');
          if (!priceMain) {
            priceMain = document.createElement('span');
            priceMain.className = 'flats__card-price-main';
            priceContainer.insertBefore(priceMain, priceContainer.firstChild);
          }

          if (priceElement.parentElement !== priceMain) {
            priceMain.prepend(priceElement);
          }

          let originalPriceElement = priceMain.querySelector('.flats__card-price-original');
          if (!originalPriceElement) {
            originalPriceElement = document.createElement('span');
            originalPriceElement.className = 'flats__card-price-original';
            originalPriceElement.style.textDecoration = 'line-through';
            originalPriceElement.style.opacity = '0.65';
            originalPriceElement.style.fontSize = '0.875em';
            originalPriceElement.style.marginLeft = '0';
            originalPriceElement.hidden = true;
            priceMain.appendChild(originalPriceElement);
          }

          if (isCampaignApplied && hasOriginalCash) {
            originalPriceElement.hidden = false;
            originalPriceElement.textContent = window.formatPrice
              ? window.formatPrice(originalCash, 0)
              : `${originalCash}`;
          } else {
            originalPriceElement.hidden = true;
            originalPriceElement.textContent = '';
          }
        }

        if (!card) return;

        let badge = card.querySelector('.flats__card-price-campaign');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'flats__card-price-campaign badge shine-tag';
          badge.hidden = true;
          card.insertBefore(badge, card.firstChild);
        }

        if (isCampaignApplied && hasValidCampaignRate) {
          badge.hidden = false;
          badge.textContent = `%${campaignRate} indirim`;
        } else {
          badge.hidden = true;
          badge.textContent = '';
        }
      });
    }

    connectedCallback() {
      if (!this.splideContainer) return;

      // Slide sayisini kontrol et
      const slides = this.splideContainer.querySelectorAll('.splide__slide');
      if (slides.length === 0) return;

      this.applyCampaignStyles();

      this.splide = new Splide(this.splideContainer, {
        type: 'slide',
        perPage: 3,
        perMove: 1,
        gap: 20,
        rewind: true,
        arrows: true,
        pagination: false,
        autoplay: true,
        interval: 5000,
        breakpoints: {
          1024: {
            arrows: false,
            pagination: true,
            perPage: 2,
          },
          768: {
            arrows: false,
            pagination: true,
            focus: 'center',
            fixedWidth: 300,
          },
        },
      });
      this.splide.mount();
    }
  }
  customElements.define('son-daireler', SonDaireler);
}
